import Vue from 'vue';

Vue.filter('truncate', function (string, length) {
  // Remove strings
  string = string.replace(/<[^>]*>/g, '');

  //trim the string to the maximum length
  let trimmedString = string.substr(0, length);

  //re-trim if we are in the middle of a word
  return trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" "))) + '...';
})



// WEBPACK FOOTER //
// ./src/filters/Truncate.js